<style lang="scss">

div.map-legend-inner {
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16),
    0 0 0 1px rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  background-color: white;
  padding: 10px;
  max-width: 200px;
  min-width: 150px;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  right: 5px;
  bottom: 20px;
  position: absolute;
  z-index: 400;

  div.legend-row {
    margin-bottom: 5px;

    img {
      margin-right: 10px;
    }
  }
  .circle {
    height: 12px;
    width: 12px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .close-legend {
    float: right;
    padding-right: 8px;
    margin-bottom: 5px;
    img {
      height: 8px;
    }
    img:hover {
      cursor: pointer;
    }
  }
}

.legend-controller {
  background-color: white;
  cursor: pointer;
  right: 5px;
  position: absolute;
  bottom: 20px;
  padding: 3px;
  border-radius: 5px;
  z-index: 400;
  img {
    height: 30px;
  }
}

@media screen and (max-width: 39.9375em) {
}
</style>

<template>
  <div>
    <div v-show="!showLegend">
      <a href="#" v-on:click="toggleLegend()" class="legend-controller">
        <img :src="require('@/assets/img/fi-info.svg')">
      </a>
    </div>
    <div v-show="showLegend">
      <div class="map-legend-inner">
        <div>
          <h6 style="float: left">Tegnforklaring</h6>
          <div class="close-legend" v-on:click="toggleLegend()">
            <img :src="require('@/assets/img/close-icon.svg')">
          </div>
          <div style="clear:both"></div>
        </div>

        <!-- <div v-show="!showNewestEstimate"> -->
          <div class="large-12 medium-12 small-12 cell legend-row">
            <span class="circle green"></span> Svært god / god
          </div>
          <div class="large-12 medium-12 small-12 cell legend-row">
            <span class="circle yellow"></span> Moderat
          </div>
          <div class="large-12 medium-12 small-12 cell legend-row">
            <span class="circle orange"></span> Dårlig
          </div>
          <div class="large-12 medium-12 small-12 cell legend-row">
            <span class="circle red"></span> Svært dårlig
          </div>
          <div class="large-12 medium-12 small-12 cell legend-row">
            <span class="circle white"></span> Usikre data
          </div>
          <div class="large-12 medium-12 small-12 cell legend-row">
            <span class="circle small darkgray small-circle-margin"></span> Ikke undersøkt
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (window.innerWidth < 480) {
        this.$store.dispatch('toggleLegendDisplay', {
          showLegend: false
        });
      }
    },
    toggleLegend() {
      this.$store.dispatch('toggleLegendDisplay', {
        showLegend: !this.showLegend
      });
    }
  },
  computed: {
    showLegend() {
      return this.$store.getters.getShowLegend;
    }
  }
};
</script>
